import { get } from '@user/store/services/crud'
import { ServiceConfig } from '@user/store/services/config'
import { toQueryString } from '@sales-center/common'
import { useEffect, useState } from 'react'
import { externalAppTimeoutError } from '@user/store/utilities/functions'

type Status = 'pending' | 'success' | 'fail'

interface Props {
  locationId: string
  nameOnCard: string
}

export const useGetEmbedUrlOnMount = (props: Props) => {
  const { locationId, nameOnCard } = props
  const [status, setStatus] = useState<Status>('pending')
  const [url, setUrl] = useState<string>('')

  useEffect(() => {
    let mounted = true

    const execute = async () => {
      try {
        const response = await get(
          `${ServiceConfig.baseAPIUrl}/Payment/store?${toQueryString({
            locationId,
            nameOnCard,
          })}`,
        )

        if (response.ok) {
          const json = await response.json()
          const url: string = json.hostedPaymentsUrl

          if (mounted) {
            setUrl(url)
            setStatus('success')
          }
        } else {
          externalAppTimeoutError(response)
          setStatus('fail')
        }
      } catch {
        if (mounted) {
          setStatus('fail')
        }
      }
    }
    execute()

    return () => {
      mounted = false
    }
  }, [locationId, nameOnCard])

  return [status, url]
}
